var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-0",attrs:{"tile":"","hover":"","height":"100%"}},[_c('v-card-text',{staticClass:"text-center"},[_c('apexchart',{attrs:{"type":"bar","height":_vm.height,"options":_vm.barOptions,"series":_vm.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }